import Entity from '../entity'

export default class Court extends Entity<number>{
    name: string = "";
    address: string = "";
    phoneNumber: string = "";
    survey: string = "";
    shortDesc: string = '';
    installations: string = "";
    longitude:string| number = 0.00 ;
    latitude: number = 0.00;
    regionId: number = 0;
    showOnHome: boolean = false;
    courtImages: Array<any> = [];
    isPreferential: boolean = false;
    isActive: boolean = false;
    displayOrder: number = 0;
    creationTime: Date;
    hasGroupBuy:boolean=true;
    englishName:string="";
    courtFacilityAss:Array<any>=[];
    //球场设施
    tunnelNumber:number=0;//洞数
    par:string="";//标准杆
    distance:number=0;//球道长度
    greenSpecies:string="";//果岭草种
    fairwaySpecies:string="";//球道草种
    courtStyle:string="";//风格
    designer:string="";//设计师
    openingTime:Date|string=''
    isShowVipPrice:boolean=false;


}
